"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const bottomNavigation = {
    MuiBottomNavigation: {
        styleOverrides: {
            root: {
                background: colors_1.default.secondary[900],
                color: colors_1.default.icons[100],
                "&.Mui-selected": {
                    color: colors_1.default.primary[900],
                },
            },
        },
    },
    MuiBottomNavigationAction: {
        styleOverrides: {
            root: {
                minWidth: "70px",
                color: colors_1.default.icons[100],
                borderTop: `solid 2px ${colors_1.default.secondary[900]}`,
                "&:hover, &.Mui-selected": {
                    borderTop: `solid 2px ${colors_1.default.primary[900]}`,
                    color: colors_1.default.primary[900],
                },
            },
        },
    },
};
exports.default = bottomNavigation;
